import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Action, DefaultPerPageValue } from "../../../constants/Common";
import { removeDeliverable } from "../../../api/casp/deliverable";
import { useParams } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { Col, Row } from "reactstrap";
import NodataFound from "../../Common/NoDataFound";
import Ticket from "../../../assets/images/icons/ticket.png";
import { DeliverableStatus, ProjectDeliverableStatus } from "../../../constants/Status";
import { hasModulePermission } from "../../../helpers/permission";
import { Modules } from "../../../constants/Module";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast } from "react-toastify";
import ShowCommentModal from "../common/ShowCommentModal";
import { withTranslation } from "react-i18next";
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import { PaginationComponent } from "../../../Components/casp/common/PaginationComponent";
import { getProjectDeliverable } from "../../../api/casp/project";
import SubmitLegalDocument from "../../ProjectSubmission/submitLegalDocument";
import SubmitDeliverable from "../../ProjectSubmission/submitDeliverable";
import SubmitSecondDeliverable from "../../ProjectSubmission/submitSecondDeliverable";
import ContentInfo from "../../../common/contentInfo";
import { MilestoneStatusColor } from "../../../constants/StatusColor";
import DescriptionIcon from "@mui/icons-material/Description";

const DeliverableAccordion = ({ disabled, projectDetails, t }) => {
  // const [isCreateMilestoneDialogOpen, setIsCreateMilestoneDialogOpen] = useState(false);
  const [deliverableList, setDeliverableList] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(DefaultPerPageValue);
  const [paginationObject, setPaginationObject] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const { project } = useParams();
  // const [openDeliverable, setOpenDeliverable] = useState([]);
  // const [deliverableId, setDeliverableId] = useState();
  // const [deliverable, setDeliverable] = useState();
  // const [refreshMilestone, setRefreshMilestone] = useState();
  // const [milestoneCreatedCost, seMilestoneCreatedCost] = useState(0);
  const [selectedDeliverable, setSelectedDeliverable] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [deletePayload, setDeletePayload] = useState({});
  const [action, setAction] = useState()
  const [triggerElement, setTriggerElement] = useState(+new Date())
  // const hasDeliverableEditPermission = hasModulePermission(Modules.DELIVERABLE, Action.EDIT)
  const [openRejectModel, setOpenRejectModel] = useState(false);
  const [rejectReason, setRejectReason] = useState();
  // const [isLoadingForSubmit, setIsLoadingForSubmit] = useState(false);
  // const hasPermission = hasModulePermission(Modules.DELIVERABLE, Action.EDIT)
  const hasSubmitPermission = hasModulePermission(Modules.DELIVERABLE, Action.SUBMIT)
  // const hasMilestoneCreatePermission = hasModulePermission(Modules.MILESTONE, Action.CREATE)
  // const [milestone, setMilestone] = useState([]);

  /** Fetch deliverable list from api */
  const fetchDeliverableList = async (paginationData) => {
    try {
      const res = (
        await getProjectDeliverable({
          ...paginationData,
          projectId: project,
          portfolioId: projectDetails?.portfolioId
        })
      ).data.data;
      setDeliverableList(res.data);
      setPaginationObject(res.meta);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleChange = async (event, newPage) => {
    setPage(newPage);
    setDeliverableList([]);
  };

  const handleChangeRowsPerPage = async (event) => {
    setDeliverableList([]);
    setPaginationObject({});
    const perPage = parseInt(event.target.value);
    setRowsPerPage(perPage);
    setPage(0);
  };

  // const manageServiceProviderAccordion = (id) => {
  //   if (openDeliverable.includes(id)) {
  //     setOpenDeliverable(openDeliverable.filter((_o) => _o !== id));
  //     setDeliverableId(id);
  //   } else {
  //     setOpenDeliverable([...openDeliverable, id]);
  //   }
  // };

  // const milestoneRefresh = async (milestone) => {
  //   const updatedMilestones = []
  //   if (deliverable.id === milestone.deliverableId) {
  //     deliverable.milestones.forEach((item) => {
  //       updatedMilestones.push(item)
  //     })
  //     updatedMilestones.push({ id: milestone.id, milestoneBudgets: [{ plannedCost: milestone.cost }] })
  //   }

  //   const updatedDeliverable = []
  //   deliverableList.forEach((del) => {
  //     if (del.id === milestone.deliverableId) {
  //       updatedDeliverable.push({ ...del, milestones: updatedMilestones })
  //     } else {
  //       updatedDeliverable.push(del)
  //     }
  //   })
  //   setDeliverableList(updatedDeliverable)
  //   setRefreshMilestone(+new Date());
  // };
  // const toggle = (_, reason) => {
  //   if (reason === 'backdropClick') {
  //     return;
  //   }
  //   setIsCreateMilestoneDialogOpen(!isCreateMilestoneDialogOpen);
  // };

  // const handleClickDelete = (params, action) => {
  //   if (action === Action.DELETE) {
  //     const payload = {
  //       projectId: parseInt(project),
  //     }
  //     setDeletePayload(payload)
  //     setSelectedDeliverable(params);
  //     setIsOpenSweetAlert(true);
  //   }
  // }

  const deleteDeliverable = async () => {
    try {
      const res = await removeDeliverable(selectedDeliverable.id, deletePayload)
      if (res.statusCode === 200) {
        toast.success(res.data.message)
        // Reset to first page after deletion if needed, or adjust logic
        if (deliverableList.length === 1 && page > 0) {
          setPage(page - 1); // Go to previous page if last item deleted
        } else {
          setTriggerElement(+new Date()); // Refresh current page
        }
        setDeliverableList([]) // Clear list before refetch
      }
    } catch (err) {
      toast.error(err.message)
    }
    finally {
      setIsOpenSweetAlert(false)
    }
  }

  useEffect(() => {
    fetchDeliverableList({ page, perPage: rowsPerPage });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage, triggerElement]);

  const handleOpenDrawer = (selectedRow, action) => {
    // Prevent opening drawer if the whole component is disabled
    if (disabled) return;
    setAction(action);
    setSelectedDeliverable(selectedRow);
    setDrawerOpen(true);
  };

  const handleCloseDrawer = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setDrawerOpen(false);
    setSelectedDeliverable();
    setAction()
  };

  const deliverableRefresh = async () => {
    // fetchDeliverableList()
    setTriggerElement(+new Date()); // Or trigger refetch
    setDeliverableList([]);
  };

  const handleOpen = (comment, data) => {
    setOpenRejectModel(true);
    setRejectReason({
      name: data?.name,
      profilePicture: data?.profilePicture,
      role: data?.projectUsers[0]?.role?.name ?? '',
      comment,
    });
  };

  const handleRejectModal = (_, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpenRejectModel(!openRejectModel);
    setRejectReason()
  };

  // useEffect(() => {
  //   if (milestone?.length > 0) {
  //     const updatedDeliverable = []
  //     deliverableList.forEach((del) => {
  //       if (del.id === milestone[0].deliverable?.id) {
  //         updatedDeliverable.push({ ...del, milestones: milestone })
  //       } else {
  //         updatedDeliverable.push(del)
  //       }
  //     })
  //     setDeliverableList(updatedDeliverable)
  //   }
  // }, [setMilestone, milestone]);

  return (
    <React.Fragment>
      {deliverableList?.length > 0 &&
        deliverableList.map((it, ind) => (
          //  expanded={openDeliverable.includes(it.id)}
          <Accordion
            key={ind}
            className="my-2 newActionIconsDarker"
            expanded={false}
          >
            <AccordionSummary
              // expandIcon={<ExpandMoreIcon style={{ color: "#1C1B1F" }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              // onClick={() => manageServiceProviderAccordion(it.id)}
              onClick={null}
              style={{ cursor: disabled ? "not-allowed" : "default" }}
            >
              <div className="vp_submission justify-content-between align-items-center">
                <div
                  className="milestone-info d-flex justify-content-between  align-items-center"
                  style={{ maxWidth: "60%", width: "100%" }}
                >
                  <Typography className="tableHeader">
                    <ListAltOutlinedIcon /> &nbsp;
                    <span
                      className="deliverableName"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleOpenDrawer(it, Action.VIEW);
                      }}
                      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
                    >
                      {it.deliverable.name}
                    </span>
                  </Typography>
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="d-flex justify-content-center mx-2">
                    <h6
                      className={`statusBadge ${MilestoneStatusColor(
                        it.currentStatus
                      )} badge-outlined mt-2 mx-2`}
                    >
                      {t(it.currentStatus)}
                      {it.currentStatus ===
                        DeliverableStatus.SUBMITTED && (
                          <ContentInfo
                            content={it?.latestApproval?.currentApprovalUser}
                          />
                        )}
                      {it.currentStatus ===
                        DeliverableStatus.REJECTED && it?.deliverable?.deliverableOrder > 2 && (
                          <DescriptionIcon
                            style={{ cursor: "pointer", height: "18px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleOpen(
                                it.previousApproval?.comments,
                                it.previousApproval?.currentApprovalUser?.user
                              );
                            }}
                          />
                        )}
                    </h6>
                  </div>

                  {/* {[ProjectStatuses.DRAFT, ProjectStatuses.REJECTED].includes(
                    projectDetails?.status
                  ) &&
                    hasMilestoneCreatePermission && (
                      // <Button
                      //   variant="contained"
                      //   className="edit_button"
                      //   disableElevation
                      //   onClick={(e) => {
                      //     e.stopPropagation();
                      //     toggle()
                      //     setDeliverable(it)
                      //     setDeliverableId(it.id);
                      //   }}
                      // >
                      // </Button>
                      <div className="newActionIcons newActionIconsDarker borderRightOnActions">
                        <Tooltip title={t("Add Milestone")}>
                          <AddOutlinedIcon
                            className="me-3"
                            onClick={(e) => {
                              e.stopPropagation();
                              toggle();
                              setDeliverable(it);
                              setDeliverableId(it.id);
                            }}
                          />
                        </Tooltip>
                      </div>
                    )} */}


                  {hasSubmitPermission &&
                    // it._count.milestones === 0 &&
                    [
                      ProjectDeliverableStatus.ONGOING,
                    ProjectDeliverableStatus.REJECTED,
                      ProjectDeliverableStatus.DELAYED
                    ].includes(it.currentStatus) && (
                      <Button
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleOpenDrawer(it, Action.SUBMIT);
                        }}
                        variant="contained"
                        className="edit_button"
                      // disabled={isLoadingForSubmit}
                      >
                        {/* {isLoadingForSubmit && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-1"
                          />
                        )} */}
                        {t("Submit")}
                      </Button>
                    )}
                </div>
              </div>
            </AccordionSummary>
            {/* <AccordionDetails>
              {openDeliverable.includes(it.id) && (
                <>
                  <MilestoneTable
                    key={refreshMilestone}
                    emitMilestone={(data) => setMilestone(data)}
                    disabled={disabled}
                    deliverable={it}
                    projectStatus={projectDetails?.status}
                  />
                </>
              )}
            </AccordionDetails> */}
          </Accordion>
        ))}
      {/* {deliverableList.length > 0 && (
        <OuterPagination
          paginationObject={paginationObject}
          handleChangePage={handleChange}
          page={page}
        />
      )} */}

      {deliverableList.length > 0 && (
        <div className="ongoingProjPagination d-flex justify-content-end mt-3 newRoundedPagination">
          <PaginationComponent
            paginationObject={paginationObject}
            page={page}
            handleChangePage={handleChange}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </div>
      )}

      {deliverableList.length === 0 && !isLoading && (
        <NodataFound text="No data found" icon={Ticket} />
      )}
      {isLoading && (
        <Col md={12}>
          <Row className="p-2">
            <Col md={12}>
              <Skeleton variant="rounded" className="p-2 m-2 h-75"></Skeleton>
            </Col>
          </Row>
          <Row className="p-2">
            <Col md={12}>
              <Skeleton variant="rounded" className="p-2 m-2 h-75"></Skeleton>
            </Col>
          </Row>
          <Row className="p-2">
            <Col md={12}>
              <Skeleton variant="rounded" className="p-2 m-2 h-75"></Skeleton>
            </Col>
          </Row>
        </Col>
      )}

      {/* <Modal
        isOpen={isCreateMilestoneDialogOpen}
        toggle={toggle}
        centered
        backdrop="static"
        style={{ maxWidth: '660px', width: '100%' }}
      > */}
      {/* <Drawer
        anchor="right"
        open={isCreateMilestoneDialogOpen}
        onClose={toggle}
        PaperProps={{
          sx: { width: "580px" },
        }}
        className="projectListDrawer"
      >
        <CreateMilestone
          isOpen={isCreateMilestoneDialogOpen}
          setIsOpen={setIsCreateMilestoneDialogOpen}
          emitProject={milestoneRefresh}
          deliverableId={deliverableId}
          deliverable={deliverable}
          milestoneCreatedCost={milestoneCreatedCost}
        />
      </Drawer> */}
      {/* </Modal> */}

      {drawerOpen && selectedDeliverable && selectedDeliverable.deliverable.deliverableOrder === 1 && (
        <SubmitLegalDocument
          isOpen={drawerOpen}
          handleClose={handleCloseDrawer}
          selectedRow={selectedDeliverable}
          refresh={deliverableRefresh}
          isDisabled={disabled ?? false}
          action={action}
          projectDetails={projectDetails}
        />
      )}

{drawerOpen && selectedDeliverable && selectedDeliverable.deliverable.deliverableOrder === 2 && (
        <SubmitSecondDeliverable
          isOpen={drawerOpen}
          handleClose={handleCloseDrawer}
          selectedRow={selectedDeliverable}
          refresh={deliverableRefresh}
          isDisabled={disabled ?? false}
          action={action}
          projectDetails={projectDetails}
        />
      )}

      {drawerOpen && selectedDeliverable && (selectedDeliverable.deliverable.deliverableOrder !== 1 && selectedDeliverable.deliverable.deliverableOrder !== 2) && (
        <SubmitDeliverable
          isOpen={drawerOpen}
          handleClose={handleCloseDrawer}
          selectedRow={selectedDeliverable}
          refresh={deliverableRefresh}
          isDisabled={disabled}
          action={action}
          projectDetails={projectDetails}
        />
      )}

      {isOpenSweetAlert && (
        <SweetAlert
          title={t("Are you sure want to delete this deliverable") + "?"}
          warning
          showCancel
          confirmBtnText={t("OK")}
          cancelBtnText={t("Cancel")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={async () => {
            await deleteDeliverable();
          }}
          onCancel={() => {
            setIsOpenSweetAlert(false);
          }}
        ></SweetAlert>
      )}

      <div className="rejectModal">
        <ShowCommentModal
          handleRejectModal={handleRejectModal}
          open={openRejectModel}
          module={Modules.CHANGE_REQUEST}
          data={rejectReason}
        />
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DeliverableAccordion);
